import React from 'react'
import { useEffect, useState } from 'react'
import moment from 'moment'
import DataTable from 'react-data-table-component';
import axios from 'axios';
import FilterComponent from '../Common/FilterComponent';


export default function Contact(props) {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(100);

    const fetchUsers = async page => {
        setLoading(true);
        const response = await axios.get(`${props.url}&page=${page}&per_page=${perPage}&delay=1`);
        setData(response.data.data.filter(item => item.data_item_type === 300));
        setTotalRows(response.data.pageCount);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        const response = await axios.get(`${props.url}&page=${page}&per_page=${newPerPage}&delay=1`);
        setData(response.data.data);
        setPerPage(newPerPage);
        setLoading(false);
    };

    useEffect(() => {
        fetchUsers(1); // fetch page 1 of users
        // eslint-disable-next-line
    }, [props.url]);

    const getData = (data) => {
        if (data) {
            return (<p dangerouslySetInnerHTML={{ __html: data.concat(" ") }} />)
        }
    }

    const columns = [
        {
            name: "Name",
            selector: row => <label title={`${row.co_first_name + " " + row.co_last_name}`}></label>,
            sortable: true,
            // width: "200px",
            cell: row => <span data-label="Name">{`${row.co_first_name + " " + row.co_last_name}`}</span>
        },
        {
            name: "Regarding",
            selector: row => <label title={row.regarding}>{row.regarding}</label>,
            sortable: true,
            cell: row => <span data-label="Regarding">{row.regarding}</span>
        },
        {
            name: "Event",
            selector: row => <label title={row.short_description}>{row.short_description}</label>,
            sortable: true,
            // width: "100px",
            cell: row => <span data-label="Event">{row.short_description}</span>
        },
        {
            name: "Activity Status",
            selector: row => <label title={row.joborder_status_type_description[row.joborder_status_type_description.length - 1]?.short_description}></label>,
            sortable: true,
            // width: "150px",
            cell: row => <span data-label="Activity Status">{row.joborder_status_type_description[row.joborder_status_type_description.length - 1]?.short_description}</span>
        },
        {
            name: "Event Notes",
            selector: row =>
                <div title={getData(row.notes)}></div>
            ,
            sortable: true,
            // width: "250px",
            cell: row => <span data-label="Event Notes">{getData(row.notes)}</span>
        },
        {
            name: "Entered By",
            selector: row => (
                row.employer_contact_name !== null
                    ? `${row.employer_contact_name} ${row.employer_name !== null ? row.employer_name : ""}`
                    : `${row.user_first_name} ${row.user_last_name}`
            ),
            sortable: true,
            // width: "100px",
            cell: row => <span data-label="Entered By">{row.employer_contact_name !== null ? `${row.employer_contact_name} ${row.employer_name !== null ? row.employer_name : ""}` : `${row.user_first_name} ${row.user_last_name}`}</span>
        },
        {
            name: "Created Time",
            selector: row => moment(row.date_created).format("MM-DD-YYYY, h:mm:ss"),
            sortable: true,
            // width: "150px",
            cell: row => <span data-label="Created Time" >{moment(row.date_created).format("MM-DD-YYYY, h:mm:ss")}</span>
        },
        // {
        //     name: "Modified Time",
        //     selector: row => moment(row.date_modified).format("MM-DD-YYYY, h:mm:ss"),
        //     sortable: true,
        //     width: "8%"
        // }
    ]

    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );

    const filteredItems = data.filter(
        item =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );


    const subHeaderComponent = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);


    return (
        <div>

            <DataTable
                // title="Contacts Activity"
                columns={columns}
                data={filteredItems}
                progressPending={loading}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                subHeader
                subHeaderComponent={subHeaderComponent}
            />
        </div>
    )
}
